import { Field } from './Field';


export class NumberField extends Field {
  type: string = "number";
  public render(): HTMLElement {
    const container = this.createContainer();
    const input = document.createElement('input');
    input.type = 'number';
    input.id = this.name;
    input.name = this.name;
    input.value = this.value;
    input.addEventListener('focusout', (event) => {
      this.value = Number((event.target as HTMLInputElement).value);
      const target = event.target as HTMLInputElement;
      this.onChange(Number(target.value),event.target as HTMLElement);
    });
    container.appendChild(input);

    return container;
  }
}
